//noticias
export const permissionsKeys = {
  page: 'news-schema.find',
  pageBlockFind: 'news-schema.find',
  pageBlockCreate: 'news-schema.create',
  pageBlockUpdate: 'news-schema.update',
  pageBlockRemove: 'news-schema.remove',
  pageBlockShareWithDependencies: 'news-schema.update',
  pageBlockShareWithUsers: 'news-schema.update',
};
